<template>
 <div class="news">
     <main class="main-area">
         <h1>{{ title }}</h1>
         <h3>{{ subtitle }}</h3>
         <p class="data">Data de publicação: {{ date }}</p>
         <div class="image">
            <carousel :perPage='1' :autoplayHoverPause="true" :paginationPadding="5" :paginationEnabled="false">
                <slide v-for="(item, index) in img" :key="index">
                    <img :src="item.imagem" alt="Ugt noticias">
                </slide>
            </carousel>
         </div>
         <div class="text">
             <p v-html="text"></p>
         </div>
     </main>
</div>
</template>

<script>
import imageMixins from '../../../../../mixins/images.mixin'
export default {
    name: 'news',
    props: {
        title: String,
        text: String,
        subtitle: String,
        date: String,
        img: Array,
    },
    mixins: [imageMixins],
}
</script>

<style lang="scss" scoped>
.news {
    @apply py-0 px-4 w-4/5;
    border-right: 2px solid rgba(0, 0, 0, 0.2);
    @media (max-width: 768px) {
        @apply w-full border-none px-0;
    }
    main{
        @apply mb-16;
        h1 {
            @apply text-3xl;
        }
        h3 {
            @apply mb-5 text-2xl;
        }
        .data {
            @apply mb-12;
        }
        .image {
            @apply object-center;
        }
        .text {
            @apply mt-4;
        }
 
    }
}
</style>
